import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import CompareSweden from "./views/compareSweden/CompareSweden";
import InternationalTradeContainer from "./views/internationalTrade/InternationalTradeContainer";
import Emi from "./views/emi/Emi";

import "./App.css";

export default function App() {
    return (
        <Router>
            <Switch>
                <Route path="/international-trade">
                    <InternationalTradeContainer />
                </Route>

                <Route path="/compare-sweden">
                    <CompareSweden />
                </Route>

                <Route path="/emi">
                    <Emi />
                </Route>

                <Route path="/">
                    <ul>
                        <li>
                            <a href="/international-trade">International Trade</a>
                        </li>
                        <li>
                            <a href="/compare-sweden">Compare Sweden</a>
                        </li>
                        <li>
                            <a href="/emi">Export Managers' Index</a>
                        </li>
                    </ul>
                </Route>
            </Switch>
        </Router>
    );
}
